








import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../domain";
import { FormatStructureEditor } from "../../domain/editableFormat";
import { FormatEditor } from "./editors";
import { FormatEditViewMixin } from "./mixins";

@Component({
  components: {
    FormatEditor,
  },
})
export default class NewCopiedFormatEditView extends Mixins(FormatEditViewMixin) {
  @Prop()
  sourceFormatId: number;

  @Prop()
  sourceArchiveId: number;

  created() {
    this.load();
  }

  async load(): Promise<void> {
    this.isLoading = true;
    const registry = DomainRegistry.instance;
    const format = await registry.editableFormat.getFormatRepository().getNewCopiedFormatStructure(this.sourceFormatId, this.sourceArchiveId);
    
    const version = format.version
      ? format.version
      : "3.00";
    const results = await Promise.all([
      format,
      await registry.editableFormat.getSpecificationRepository().getSpecification(version),
    ]);
    this.isLoading = false;
    this.model = new FormatStructureEditor(results[0], results[1]);
    this.model.setCommandCountMax(this.$configuration.formatEditor.behavior.format.editor.commandManager.max);
  }
}
